module.exports = __webpack_public_path__ + "static/media/venue-type.c41c9b3b.jpeg";